(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-telas"] && !Shopify.designMode) return;
  try {
    
  // Setas do trilho no desktop: rolam uma tela por clique, com o snap fazendo o resto.
  (function () {
    var rm = function () { return document.documentElement.classList.contains('rm'); };
    function montar(raiz) {
      raiz.querySelectorAll('[data-app-telas] [data-setas]').forEach(function (s) { s.hidden = false; });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-app-telas] [data-passo]'); if (!b) return;
      var trilho = b.closest('[data-app-telas]').querySelector('[data-trilho]'); if (!trilho) return;
      var tela = trilho.querySelector('.atelas__tela'); var passo = tela ? tela.getBoundingClientRect().width + 20 : 300;
      trilho.scrollBy({ left: passo * parseInt(b.dataset.passo, 10), behavior: rm() ? 'auto' : 'smooth' });
    });
    montar(document);
    document.addEventListener('shopify:section:load', function (e) { montar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabecalho"]) return;
  try {
    
  // Menu movel: um botao com aria-expanded, um painel, foco que entra e volta, Esc fecha.
  // Delegado no documento para sobreviver ao recarregamento de secao do editor.
  // Contagem do carrinho: ouve carrinho:atualizado (disparado pelas secoes do carrinho com
  // detail.cart) e reescreve o numero, o hidden e o rotulo acessivel.
  (function () {
    function cabecalhoDe(el) { return el.closest('[data-cabecalho]'); }
    function alternar(cab, abrir) {
      var botao = cab.querySelector('[data-menu-botao]');
      var painel = cab.querySelector('[data-menu-painel]');
      if (!botao || !painel) return;
      cab.classList.toggle('is-aberto', abrir);
      botao.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      botao.setAttribute('aria-label', abrir ? botao.dataset.rotuloFechar : botao.dataset.rotuloAbrir);
      if (abrir) {
        var primeiro = painel.querySelector('a, button');
        if (primeiro) primeiro.focus();
      } else if (document.activeElement && painel.contains(document.activeElement)) {
        botao.focus();
      }
    }
    document.addEventListener('click', function (e) {
      var botao = e.target.closest('[data-menu-botao]');
      if (botao) {
        var cab = cabecalhoDe(botao);
        alternar(cab, !cab.classList.contains('is-aberto'));
        return;
      }
      var aberto = document.querySelector('[data-cabecalho].is-aberto');
      if (aberto && !aberto.contains(e.target)) alternar(aberto, false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var aberto = document.querySelector('[data-cabecalho].is-aberto');
      if (aberto) alternar(aberto, false);
    });
    // o painel movel so fechava por clique fora ou Escape: quem sai dele com Tab continuava
    // navegando a pagina por baixo do painel aberto. Sair pelo teclado tambem fecha.
    document.addEventListener('focusout', function (e) {
      var aberto = document.querySelector('[data-cabecalho].is-aberto');
      if (!aberto || !aberto.contains(e.target)) return;
      var indo = e.relatedTarget;
      if (indo && aberto.contains(indo)) return;
      if (!indo) return;
      aberto.classList.remove('is-aberto');
      var botao = aberto.querySelector('[data-menu-botao]');
      if (botao) { botao.setAttribute('aria-expanded', 'false'); botao.setAttribute('aria-label', botao.dataset.rotuloAbrir); }
    });
    // no editor, ao trocar de secao, o painel volta fechado
    document.addEventListener('shopify:section:unload', function (e) {
      var cab = e.target.querySelector('[data-cabecalho].is-aberto');
      if (cab) alternar(cab, false);
    });

    // B01: na pagina de produto o Comprar vai a caixa de compra da propria pagina, sem trocar a
    // URL. Desconta a altura do cabecalho fixo. So nao rola quando a caixa ja comeca na metade
    // de cima (desktop, onde ela e sticky ao lado da galeria) e o alvo do foco esta inteiro na
    // tela; se, com a caixa no topo, o alvo ainda ficar abaixo da dobra, rola ate o alvo. O radio
    // do tamanho e sr-only: quem conta e a pilula em volta dele. Sem JS, o href faz o salto.
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cabecalho-caixa]');
      if (!a) return;
      var caixa = document.querySelector('[data-caixa-compra]') || document.getElementById('caixa-compra');
      if (!caixa) return;
      e.preventDefault();
      var cab = cabecalhoDe(a);
      if (cab && cab.classList.contains('is-aberto')) alternar(cab, false);
      var alvo = caixa.querySelector('[data-opcao-grupo="tamanho"] input') || caixa.querySelector('[data-comprar]');
      var visto = (alvo && (alvo.closest('label') || alvo)) || caixa;
      var folga = (cab ? cab.getBoundingClientRect().height : 0) + 16;
      var fundo = window.innerHeight - 16;
      var topo = caixa.getBoundingClientRect().top;
      var r = visto.getBoundingClientRect();
      if (topo < folga || topo > window.innerHeight / 2 || r.top < folga || r.bottom > fundo) {
        var desloca = topo - folga;
        if (r.bottom - desloca > fundo) desloca = r.bottom - fundo;
        window.scrollTo({ top: Math.max(0, window.scrollY + desloca), behavior: document.documentElement.classList.contains('rm') ? 'auto' : 'smooth' });
      }
      if (alvo) alvo.focus({ preventScroll: true });
    });

    // A escolha da Home (H3, "No pulso ou no dedo?"): o home-hero dispara ezeed:escolha com
    // 'band' ou 'anel' e o Comprar troca o href pela URL que o Liquid escreveu no proprio botao
    // (data-comprar-band, data-comprar-anel). Nada do evento vira URL; na PDP o botao e o da
    // caixa e nao tem as duas URLs.
    document.addEventListener('ezeed:escolha', function (e) {
      var lado = e.detail === 'anel' || e.detail === 'band' ? e.detail : '';
      if (!lado) return;
      document.querySelectorAll('[data-cabecalho-comprar]').forEach(function (a) {
        var url = a.getAttribute('data-comprar-' + lado);
        if (url) a.setAttribute('href', url);
      });
    });

    document.addEventListener('carrinho:atualizado', function (e) {
      var carrinho = e.detail && e.detail.cart;
      if (!carrinho || typeof carrinho.item_count !== 'number') return;
      var n = carrinho.item_count;
      document.querySelectorAll('[data-carrinho-contagem]').forEach(function (el) {
        el.textContent = String(n);
        el.hidden = n === 0;
        el.classList.remove('is-mudou');
        // reflow entre remover e por a classe, senao a animacao nao reinicia
        void el.offsetWidth;
        el.classList.add('is-mudou');
        var link = el.closest('[data-carrinho-link]');
        if (link) link.setAttribute('aria-label', n === 1 ? link.dataset.rotuloUm : link.dataset.rotuloVarios.replace('[n]', String(n)));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrinho-combina"] && !Shopify.designMode) return;
  try {
    
  // O submit do cartao vira um pedido a lista do carrinho (carrinho:adicionar), que faz o
  // fetch e troca esta secao pelo HTML devolvido. Sem a lista na pagina, o form segue nativo.
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-combina-form]');
      if (!form || !document.querySelector('[data-carrinho]')) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]'), botao = form.querySelector('[name="add"]');
      document.dispatchEvent(new CustomEvent('carrinho:adicionar', { detail: { id: parseInt(id.value, 10), quantidade: 1, origem: botao } }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrinho-lista"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rm = function () { return document.documentElement.classList.contains('rm'); };
    function secao() { return document.querySelector('[data-carrinho]'); }
    function ids() { return Array.prototype.map.call(document.querySelectorAll('[data-carrinho-secao]'), function (el) { return el.dataset.carrinhoSecao; }); }
    // o marcador do money_format e montado por partes: o bloco de script precisa ser estatico
    var MARCA = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
    function formato() { var sec = secao(); return sec ? sec.dataset.formato : '{' + '{amount_with_comma_separator}' + '}'; }

    // shop.money_format com o marcador amount e as variantes de separador da Shopify
    function formatar(centavos) {
      var f = formato(), m = f.match(MARCA), tipo = m ? m[1] : 'amount';
      var dec = /no_decimals/.test(tipo) ? 0 : 2, milhar = ',', decimal = '.';
      if (/comma_separator/.test(tipo)) { milhar = '.'; decimal = ','; }
      else if (/period_and_space/.test(tipo)) { milhar = ' '; decimal = '.'; }
      else if (/space_separator/.test(tipo)) { milhar = ' '; decimal = ','; }
      else if (/apostrophe/.test(tipo)) { milhar = "'"; decimal = '.'; }
      var partes = (centavos / 100).toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milhar);
      return f.replace(MARCA, partes.join(decimal));
    }

    function pedir(url, corpo) {
      corpo.sections = ids().join(',');
      corpo.sections_url = location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(corpo) }).then(json);
    }
    // 502 do theme dev e 429/5xx da Shopify devolvem HTML: r.json() viraria um SyntaxError em
    // ingles dentro da caixa de erro. Le como texto e so entao tenta o JSON.
    function json(r) {
      return r.text().then(function (t) {
        var j = null; try { j = JSON.parse(t); } catch (err) { j = null; }
        if (!r.ok || !j) throw (j || {});
        return j;
      });
    }
    function carrinhoAtual() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(json); }

    function erro(msg) {
      var caixa = document.querySelector('[data-carrinho-erro]');
      if (!caixa) return;
      caixa.textContent = msg || '';
      caixa.hidden = !msg;
    }
    // montagem pelo contrato: o movimento.js ouve shopify:section:load e monta so o alvo
    function montar(el) { el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true })); }

    // troca uma secao inteira pelo HTML que a Shopify devolveu e monta a nova
    function trocar(id, html) {
      var atual = document.querySelector('[data-carrinho-secao="' + id + '"]');
      if (!atual || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nova = doc.querySelector('[data-carrinho-secao="' + id + '"]');
      if (!nova) {
        // a secao nao renderizou nada (resumo com carrinho vazio, cross-sell sem sobra): fica um
        // marcador escondido com o id, para a proxima troca ainda pedir essa secao a Shopify
        nova = document.createElement('div'); nova.dataset.carrinhoSecao = id; nova.hidden = true;
        if (atual.hasAttribute('data-carrinho-composicao')) nova.setAttribute('data-carrinho-composicao', '');
        atual.replaceWith(nova);
        return;
      }
      atual.replaceWith(nova);
      montar(nova);
    }

    // as duracoes vem dos tokens (--d-estado e --d-comp), como o movimento.js le --d-conta: nada digitado
    function ms(nome, padrao) { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(nome)); return isNaN(v) ? padrao : v; }
    // o foco estava no Remover da linha que saiu: vai para o Remover vizinho, ou para o titulo
    function devolverFoco(li) {
      if (!li.contains(document.activeElement)) return;
      var irmao = li.nextElementSibling || li.previousElementSibling;
      var alvo = irmao && irmao.querySelector('[data-remover]');
      if (!alvo) alvo = document.querySelector('[data-carrinho] h1');
      if (alvo) { if (alvo.tabIndex < 0 && !alvo.hasAttribute('href')) alvo.tabIndex = -1; alvo.focus(); }
    }
    function sair(li) {
      devolverFoco(li);
      if (rm()) { li.remove(); return; }
      var dEstado = ms('--d-estado', 160), dComp = ms('--d-comp', 240);
      li.style.height = li.offsetHeight + 'px';
      li.classList.add('is-saindo');
      setTimeout(function () { li.classList.add('is-fechando'); }, dEstado);
      setTimeout(function () { li.remove(); }, dEstado + dComp);
    }
    function entrar(lista, li) {
      li.style.setProperty('--i', '0');
      li.classList.add('is-entrando');
      lista.appendChild(li);
      requestAnimationFrame(function () { requestAnimationFrame(function () { li.classList.remove('is-entrando'); }); });
    }

    function resumo(cart) {
      var sub = document.querySelector('[data-resumo-subtotal]');
      if (sub) {
        sub.dataset.alvo = (cart.total_price / 100).toFixed(2);
        // o contador e o do contrato: remontado, conta de novo ate o valor novo
        montar(sub);
      }
      // so existe com parcelas_sem_juros ligado: desligado, a linha "no cartao" nao tem valor para refazer
      var p = document.querySelector('[data-resumo-parcela]');
      if (p && p.dataset.modelo) {
        var n = parseInt(p.dataset.parcelas, 10) || 1;
        // para cima ao centavo, a mesma conta do Liquid (P08): a soma das parcelas nunca fica abaixo do total
        p.textContent = p.dataset.modelo.replace('[valor]', formatar(Math.ceil(cart.total_price / n)));
      }
    }

    function aplicar(cart, sections, composicaoMudou) {
      var sec = secao(), lista = sec && sec.querySelector('[data-carrinho-linhas]');
      if (!lista || cart.item_count === 0) {
        // vazio <-> cheio: as secoes inteiras vem prontas da Shopify
        ids().forEach(function (id) { trocar(id, sections && sections[id]); });
      } else {
        var porChave = {};
        cart.items.forEach(function (it) { porChave[it.key] = it; });
        lista.querySelectorAll('[data-linha]').forEach(function (li) {
          var it = porChave[li.dataset.key];
          if (!it) { sair(li); return; }
          var inp = li.querySelector('[data-quantidade]');
          if (inp && document.activeElement !== inp) inp.value = it.quantity;
          var tot = li.querySelector('[data-linha-total]'); if (tot) tot.textContent = formatar(it.final_line_price);
          var cada = li.querySelector('[data-linha-cada]'); if (cada) cada.textContent = formatar(it.final_price);
          var rot = li.querySelector('[data-linha-cada-rotulo]'); if (rot) rot.hidden = it.quantity < 2;
        });
        var html = sections && sections[sec.dataset.carrinhoSecao];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-linha]').forEach(function (li) {
            if (!lista.querySelector('[data-linha][data-key="' + CSS.escape(li.dataset.key) + '"]')) entrar(lista, li);
          });
          var n = doc.querySelector('[data-carrinho-n]'), nAtual = sec.querySelector('[data-carrinho-n]');
          if (n && nAtual) nAtual.textContent = n.textContent;
        }
        resumo(cart);
        // o que depende de quais produtos estao no carrinho (o cross-sell, que so aparece com o anel;
        // a troca de tamanho, que so aparece com item de tamanho; a garantia estendida, que so
        // aparece com o anel ou a Band) so muda quando a composicao muda: essas secoes levam
        // data-carrinho-composicao e sao trocadas inteiras pelo HTML devolvido
        if (composicaoMudou) ids().forEach(function (id) { if (id !== sec.dataset.carrinhoSecao && document.querySelector('[data-carrinho-composicao][data-carrinho-secao="' + id + '"]')) trocar(id, sections && sections[id]); });
      }
      erro('');
      dizer(cart);
      document.dispatchEvent(new CustomEvent('carrinho:atualizado', { detail: { cart: cart } }));
    }

    // regiao viva: subtotal e contagem mudavam em silencio para quem usa leitor de tela
    function dizer(cart) {
      var caixa = document.querySelector('[data-carrinho-status]'), sec = secao();
      if (!caixa || !sec) return;
      var d = sec.dataset;
      if (!cart.item_count) { caixa.textContent = d.statusVazio || ''; return; }
      var itens = cart.item_count === 1 ? d.statusUm : (d.statusVarios || '').replace('[n]', cart.item_count);
      caixa.textContent = (d.statusModelo || '').replace('[itens]', itens).replace('[valor]', formatar(cart.total_price));
    }

    function mudar(li, quantidade) {
      var chave = li.dataset.key, antes = li.querySelector('[data-quantidade]');
      var valorAntes = antes ? antes.defaultValue : null;
      li.classList.add('is-carregando'); li.setAttribute('aria-busy', 'true');
      pedir('/cart/change.js', { id: chave, quantity: quantidade })
        .then(function (cart) {
          var sections = cart.sections; delete cart.sections;
          if (antes) antes.defaultValue = String(quantidade);
          aplicar(cart, sections, quantidade === 0);
        })
        .catch(function (e) {
          if (antes && valorAntes !== null) antes.value = valorAntes;
          erro((e && e.description) || secao().dataset.erroPadrao);
        })
        .then(function () { if (li.isConnected) { li.classList.remove('is-carregando'); li.removeAttribute('aria-busy'); } });
    }

    function adicionar(id, quantidade, origem) {
      if (origem) { origem.classList.add('is-carregando'); origem.setAttribute('aria-busy', 'true'); }
      pedir('/cart/add.js', { items: [{ id: id, quantity: quantidade || 1 }] })
        .then(function (resposta) {
          var sections = resposta.sections;
          return carrinhoAtual().then(function (cart) { aplicar(cart, sections, true); });
        })
        .catch(function (e) { erro((e && e.description) || secao().dataset.erroPadrao); })
        .then(function () { if (origem && origem.isConnected) { origem.classList.remove('is-carregando'); origem.removeAttribute('aria-busy'); } });
    }

    var espera = null;
    document.addEventListener('click', function (e) {
      var passo = e.target.closest('[data-quant-passo]');
      if (passo) {
        var li = passo.closest('[data-linha]'), inp = li.querySelector('[data-quantidade]');
        var q = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(passo.dataset.quantPasso, 10));
        inp.value = q; mudar(li, q); return;
      }
      var rem = e.target.closest('[data-remover]');
      if (rem) { e.preventDefault(); mudar(rem.closest('[data-linha]'), 0); }
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-quantidade]')) return;
      var li = e.target.closest('[data-linha]'), q = Math.max(0, parseInt(e.target.value, 10) || 0);
      clearTimeout(espera); espera = setTimeout(function () { mudar(li, q); }, 250);
    });
    // com JS o form nativo nao recarrega: Enter no campo vira a mesma atualizacao ao vivo
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-carrinho-form]');
      if (!form || (e.submitter && e.submitter.name === 'checkout')) return;
      e.preventDefault();
      form.querySelectorAll('[data-linha]').forEach(function (li) {
        var inp = li.querySelector('[data-quantidade]');
        if (inp && inp.value !== inp.defaultValue) mudar(li, Math.max(0, parseInt(inp.value, 10) || 0));
      });
    });
    document.addEventListener('carrinho:adicionar', function (e) {
      var d = e.detail || {};
      if (d.id) adicionar(d.id, d.quantidade, d.origem);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrinho-resumo"] && !Shopify.designMode) return;
  try {
    
  // No celular os detalhes nascem fechados (a barra fixa precisa ser baixa); no desktop ficam
  // abertos e o summary some. Sem JS: abertos, e a barra e mais alta, mas nada se perde.
  (function () {
    var mq = matchMedia('(max-width: 899px)');
    function ajustar() { document.querySelectorAll('[data-resumo-mais]').forEach(function (d) { d.open = !mq.matches; }); }
    ajustar();
    mq.addEventListener('change', ajustar);
    document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('[data-resumo-mais]')) ajustar(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comofunciona-barra"] && !Shopify.designMode) return;
  try {
    
  // A escolha da pagina Como funciona e a barra do caminho. O estado e um atributo no <html>;
  // o CSS faz o resto. Delegado no documento para sobreviver ao editor da Shopify.
  (function () {
    var html = document.documentElement;
    var rm = function () { return html.classList.contains('rm'); };
    var atual = function () { return html.getAttribute('data-cf-escolha') === 'anel' ? 'anel' : 'band'; };
    var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
    var fmt = function (v, d) { return v.toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    var barra = null, links = [], alvos = [], pendente = false;

    function marcar() {
      var v = atual();
      document.querySelectorAll('[data-cf-escolher][aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-cf-escolher') === v ? 'true' : 'false'); });
    }
    // o numero que ja contou conta de novo quando a troca o traz para a tela
    function recontar(v) {
      if (rm()) return;
      var vh = innerHeight;
      document.querySelectorAll('[data-cf-v="' + v + '"] [data-count], [data-cf-so="' + v + '"] [data-count]').forEach(function (el) {
        var alvo = parseFloat(el.getAttribute('data-alvo')), dec = parseInt(el.getAttribute('data-dec') || '0', 10);
        if (isNaN(alvo) || el.textContent.trim() !== fmt(alvo, dec)) return;
        var r = el.getBoundingClientRect(); if (!r.height || r.bottom < 0 || r.top > vh) return;
        var dur = parseFloat(el.getAttribute('data-dur')) || 900, t0 = performance.now(), id = (el._cf = (el._cf || 0) + 1);
        el.textContent = fmt(0, dec);
        requestAnimationFrame(function passo(t) {
          if (id !== el._cf) return;
          var k = Math.min(1, (t - t0) / dur);
          el.textContent = fmt((1 - Math.pow(1 - k, 3)) * alvo, dec);
          if (k < 1) requestAnimationFrame(passo);
        });
      });
    }
    function escolher(v, calado) {
      if (v !== 'band' && v !== 'anel') return;
      if (v === atual() && html.hasAttribute('data-cf-escolha')) return;
      html.setAttribute('data-cf-escolha', v);
      marcar();
      if (calado) return;
      var aviso = barra && barra.querySelector('[data-cf-aviso]');
      if (aviso) aviso.textContent = barra.getAttribute('data-aviso-' + v) || '';
      requestAnimationFrame(function () {
        recontar(v);
        document.dispatchEvent(new CustomEvent('cf:escolha', { detail: v }));
        pedir();
      });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var b = e.target.closest('[data-cf-escolher]');
      if (b) { e.preventDefault(); escolher(b.getAttribute('data-cf-escolher')); return; }
      // ancora da barra e do indice: rola suave (seco com movimento reduzido) e leva o foco junto
      var a = e.target.closest('a[data-cf-ancora]');
      if (!a) return;
      var alvo = document.getElementById((a.getAttribute('href') || '').slice(1));
      if (!alvo) return;
      e.preventDefault();
      alvo.scrollIntoView({ behavior: rm() ? 'auto' : 'smooth', block: 'start' });
      if (!alvo.hasAttribute('tabindex')) alvo.setAttribute('tabindex', '-1');
      alvo.focus({ preventScroll: true });
      if (history.replaceState) history.replaceState(null, '', '#' + alvo.id);
    });

    // a barra: aparece com o passo 1, some depois do passo 7; o fio anda com a rolagem
    function tick() {
      pendente = false;
      if (!barra || !barra.classList.contains('is-pronta') || !alvos.length) return;
      var vh = innerHeight, linha = vh * 0.42, rs = [];
      for (var i = 0; i < alvos.length; i++) rs.push(alvos[i] ? alvos[i].getBoundingClientRect() : null);
      var primeiro = null, ultimo = null, agora = -1, frac = 0;
      rs.forEach(function (r, i) {
        if (!r) return;
        if (!primeiro) primeiro = r;
        ultimo = r;
        if (r.top <= linha) { agora = i; frac = clamp((linha - r.top) / Math.max(1, r.height)); }
      });
      if (!primeiro) return;
      var ligada = primeiro.top < vh * 0.55 && ultimo.bottom > vh * 0.38;
      var prog = agora < 0 ? 0 : (agora + frac) / rs.length;
      barra.classList.toggle('is-ligada', ligada);
      barra.style.setProperty('--cf-prog', prog.toFixed(4));
      links.forEach(function (a, i) {
        if (i === agora) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
        a.classList.toggle('is-feito', i < agora);
      });
    }
    // o script vai no pacote de todas as paginas: sem a barra na pagina, a rolagem nao pede quadro nenhum
    function pedir() { if (barra && !pendente) { pendente = true; requestAnimationFrame(tick); } }
    addEventListener('scroll', pedir, { passive: true });
    addEventListener('resize', pedir);

    function iniciar() {
      barra = document.querySelector('[data-cf-barra]');
      if (!barra) return;
      var q = null;
      try { q = new URLSearchParams(location.search).get('aparelho'); } catch (e) { q = null; }
      escolher(q === 'anel' ? 'anel' : atual(), true);
      document.querySelectorAll('[data-cf-escolher][hidden], [data-cf-seletor][hidden]').forEach(function (b) { b.hidden = false; });
      links = Array.prototype.slice.call(barra.querySelectorAll('[data-cf-passo]'));
      alvos = links.map(function (a) { return document.getElementById(a.getAttribute('data-cf-passo')); });
      barra.classList.add('is-pronta');
      pedir();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comofunciona-instala"] && !Shopify.designMode) return;
  try {
    
  // Passo 4: voltando para a Band com o celular na tela, a busca e digitada de novo. A primeira
  // digitacao e do movimento.js (data-type); aqui so a repeticao, com o mesmo texto e ritmo.
  (function () {
    var rm = function () { return document.documentElement.classList.contains('rm'); };
    document.addEventListener('cf:escolha', function (e) {
      if (e.detail !== 'band' || rm()) return;
      document.querySelectorAll('[data-cfi] [data-cfi-digita].is-in').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        var texto = el.getAttribute('data-text') || '', ms = parseFloat(el.getAttribute('data-ms') || '90'), i = 0, id = (el._cfi = (el._cfi || 0) + 1);
        el.classList.remove('is-pronto');
        el.textContent = '';
        var f = function () {
          if (id !== el._cfi) return;
          el.textContent = texto.slice(0, ++i);
          if (i < texto.length) setTimeout(f, ms); else setTimeout(function () { if (id === el._cfi) el.classList.add('is-pronto'); }, 500);
        };
        setTimeout(f, 300);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comofunciona-le"] && !Shopify.designMode) return;
  try {
    
  // Passo 7: as tres telas viram abas. So a aba ativa aparece (as outras saem do layout, e o
  // observador de video do movimento.js as pausa sozinho). Setas, Home e End movem entre as abas.
  (function () {
    function montar(raiz) {
      (raiz || document).querySelectorAll('[data-cfl]').forEach(function (sec) {
        var abas = sec.querySelector('[data-cfl-abas]');
        var paineis = Array.prototype.slice.call(sec.querySelectorAll('[data-cfl-painel]'));
        if (!abas || paineis.length < 2) return;
        var botoes = Array.prototype.slice.call(abas.querySelectorAll('[role="tab"]'));
        paineis.forEach(function (p, i) {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('aria-labelledby', botoes[i] ? botoes[i].id : '');
          // o painel nao tem nada focavel dentro: ele mesmo entra na ordem do Tab (padrao de abas da WAI)
          p.setAttribute('tabindex', '0');
          p.hidden = i !== 0;
        });
        abas.hidden = false;
        sec.classList.add('is-abas');
        function ativar(i, foco) {
          botoes.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
          paineis.forEach(function (p, j) { p.hidden = j !== i; });
          if (foco) botoes[i].focus();
        }
        botoes.forEach(function (b, i) {
          b.addEventListener('click', function () { ativar(i, false); });
          b.addEventListener('keydown', function (e) {
            var n = botoes.length, alvo = -1;
            if (e.key === 'ArrowRight') alvo = (i + 1) % n;
            else if (e.key === 'ArrowLeft') alvo = (i - 1 + n) % n;
            else if (e.key === 'Home') alvo = 0;
            else if (e.key === 'End') alvo = n - 1;
            if (alvo < 0) return;
            e.preventDefault();
            ativar(alvo, true);
          });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { montar(document); }); else montar(document);
    document.addEventListener('shopify:section:load', function (e) { montar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comofunciona-usa"] && !Shopify.designMode) return;
  try {
    
  // Passo 6: o relogio da cena presa. Segura na hora de cada cena e corre ate a proxima nos
  // ultimos 40% da fatia, com a mesma conta de progresso do movimento.js (topo da cena ate o pe).
  (function () {
    var pendente = false, cenas = [];
    var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
    var hhmm = function (m) { m = Math.round(m); var h = Math.floor(m / 60) % 24, mm = m % 60; return (h < 10 ? '0' : '') + h + ':' + (mm < 10 ? '0' : '') + mm; };
    function montar() {
      cenas = [];
      document.querySelectorAll('[data-cfd-pin]').forEach(function (pin) {
        var vs = [];
        pin.querySelectorAll('[data-cfd-v]').forEach(function (v) {
          var mins = (v.getAttribute('data-mins') || '').split(',').map(Number).filter(function (x) { return !isNaN(x); });
          var el = v.querySelector('[data-cfd-hora]');
          if (mins.length && el) vs.push({ mins: mins, el: el, ultimo: '' });
        });
        if (vs.length) cenas.push({ pin: pin, vs: vs });
      });
      pedir();
    }
    function tick() {
      pendente = false;
      var vh = innerHeight;
      var ps = cenas.map(function (c) { var r = c.pin.getBoundingClientRect(), total = r.height - vh; return total > 0 ? clamp(-r.top / total) : 1; });
      cenas.forEach(function (c, i) {
        c.vs.forEach(function (v) {
          var n = v.mins.length, t = ps[i] * n, k = Math.min(n - 1, Math.floor(t)), f = t - k, m = v.mins[k];
          if (k < n - 1) { var e = clamp((f - 0.6) / 0.4); e = e * e * (3 - 2 * e); m = v.mins[k] + e * (v.mins[k + 1] - v.mins[k]); }
          var txt = hhmm(m);
          if (txt !== v.ultimo) { v.el.textContent = txt; v.ultimo = txt; }
        });
      });
    }
    function pedir() { if (!pendente && cenas.length) { pendente = true; requestAnimationFrame(tick); } }
    addEventListener('scroll', pedir, { passive: true });
    addEventListener('resize', pedir);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montar); else montar();
    document.addEventListener('shopify:section:load', montar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["conta-enderecos"] && !Shopify.designMode) return;
  try {
    
  // O pais salvo precisa ser marcado no select, e excluir pede confirmacao.
  (function () {
    document.querySelectorAll('[data-pais]').forEach(function (sel) {
      var pais = sel.dataset.pais;
      if (!pais) return;
      Array.prototype.some.call(sel.options, function (op) {
        if (op.value === pais || op.textContent === pais) { op.selected = true; return true; }
        return false;
      });
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-excluir-endereco]');
      if (form && !window.confirm(form.dataset.confirmar)) e.preventDefault();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-dia"] && !Shopify.designMode) return;
  try {
    
  // O relogio da cena presa: le a posicao da secao num rAF e escreve a hora, o arco, as marcas
  // passadas e a cena ativa. Em movimento reduzido nao roda: o CSS mostra os quadros em fila.
  (function () {
    var html = document.documentElement;
    var dois = function (n) { return (n < 10 ? '0' : '') + n; };
    function montar(dia) {
      if (dia._relogio) return;
      dia._relogio = true;
      var horaEl = dia.querySelector('[data-dia-hora]'), arco = dia.querySelector('[data-dia-arco]'), palco = dia.querySelector('.dia__palco');
      var pendente = false;
      function tick() {
        pendente = false;
        if (!dia.isConnected || html.classList.contains('rm')) return;
        var vh = innerHeight, r = dia.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        // o palco prende abaixo do cabecalho: a viagem presa e a altura da secao menos a do palco
        var topo = palco ? parseFloat(getComputedStyle(palco).top) || 0 : 0, alto = palco ? palco.offsetHeight : vh;
        var total = r.height - alto, p = total > 0 ? Math.max(0, Math.min(1, (topo - r.top) / total)) : 0;
        var v = html.getAttribute('data-escolha') === 'anel' ? 'anel' : 'band';
        var hora = 6 + p * 17.9, hh = Math.floor(hora), mm = Math.floor((hora - hh) * 6) * 10;
        if (horaEl) horaEl.textContent = dois(hh) + ':' + dois(mm);
        if (arco) arco.style.strokeDashoffset = (1 - (hora - 6) / 24).toFixed(4);
        var cenas = dia.querySelectorAll('.dia__cenas[data-so="' + v + '"] .dia__cena'), ativa = 0;
        cenas.forEach(function (c, i) { if (hora >= +c.getAttribute('data-h')) ativa = i; });
        cenas.forEach(function (c, i) { c.classList.toggle('is-agora', i === ativa); });
        dia.querySelectorAll('.dia__marcas[data-so="' + v + '"] circle').forEach(function (m) { m.classList.toggle('is-passou', hora >= +m.getAttribute('data-h')); });
      }
      function pedir() { if (!pendente) { pendente = true; requestAnimationFrame(tick); } }
      addEventListener('scroll', pedir, { passive: true });
      addEventListener('resize', pedir);
      document.addEventListener('ezeed:escolha', pedir);
      tick();
    }
    function iniciar() { document.querySelectorAll('[data-dia]').forEach(montar); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  // A escolha da Home (H3) e a barra de compra. O estado e um atributo no <html>; o CSS faz o
  // resto. Delegado no documento para sobreviver ao editor da Shopify.
  (function () {
    var html = document.documentElement;
    var atual = function () { return html.getAttribute('data-escolha') === 'anel' ? 'anel' : 'band'; };
    var fmt = function (v, d) { return v.toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d }); };

    function marcar() {
      var v = atual();
      document.querySelectorAll('[data-pressiona]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-escolher') === v ? 'true' : 'false'); });
    }
    // o link vira botao de alternancia so com JS; sem ele continua link para a pagina do produto
    function preparar() {
      document.querySelectorAll('a[data-escolher]').forEach(function (a) { a.setAttribute('role', 'button'); });
      marcar();
      pedir();
    }
    // o numero que ja contou conta de novo quando a escolha o traz para a tela
    function recontar(v) {
      if (html.classList.contains('rm')) return;
      var vh = innerHeight;
      document.querySelectorAll('[data-so="' + v + '"] [data-count], [data-so="' + v + '"][data-count], [data-t="' + v + '"] [data-count]').forEach(function (el) {
        var alvo = parseFloat(el.getAttribute('data-alvo')), dec = parseInt(el.getAttribute('data-dec') || '0', 10);
        if (isNaN(alvo) || el.textContent.trim() !== fmt(alvo, dec)) return;
        var r = el.getBoundingClientRect(); if (!r.height || r.bottom < 0 || r.top > vh) return;
        var dur = parseFloat(el.getAttribute('data-dur')) || 900, t0 = performance.now(), id = (el._rc = (el._rc || 0) + 1);
        el.textContent = fmt(0, dec);
        requestAnimationFrame(function passo(t) {
          if (id !== el._rc) return;
          var k = Math.min(1, (t - t0) / dur);
          el.textContent = fmt((1 - Math.pow(1 - k, 3)) * alvo, dec);
          if (k < 1) requestAnimationFrame(passo);
        });
      });
    }
    // o video da Band: aparece quando toca; pausa fora da escolha e com movimento reduzido.
    // Tocar e pausar ao entrar e sair da tela e do movimento.js (data-video-auto).
    function videoHero() {
      var rm = html.classList.contains('rm');
      document.querySelectorAll('[data-hero-video]').forEach(function (v) {
        if (rm || atual() !== 'band') {
          v.pause();
          if (rm) v.classList.remove('is-tocando');
          return;
        }
        var r = v.getBoundingClientRect();
        if (r.bottom > 0 && r.top < innerHeight) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    }
    document.addEventListener('playing', function (e) {
      var v = e.target;
      if (!v.matches || !v.matches('[data-hero-video]')) return;
      if (html.classList.contains('rm') || atual() !== 'band') { v.pause(); return; }
      v.classList.add('is-tocando');
    }, true);
    var mmRm = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
    if (mmRm && mmRm.addEventListener) mmRm.addEventListener('change', videoHero);

    function escolher(v) {
      if ((v !== 'band' && v !== 'anel') || v === atual()) return;
      html.setAttribute('data-escolha', v);
      marcar();
      videoHero();
      requestAnimationFrame(function () {
        recontar(v);
        document.dispatchEvent(new CustomEvent('ezeed:escolha', { detail: v }));
        pedir();
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-escolher]') : null;
      if (!b) return;
      e.preventDefault();
      escolher(b.getAttribute('data-escolher'));
    });
    // Enter ja clica no link; Espaco e o outro atalho de botao
    document.addEventListener('keydown', function (e) {
      if (e.key !== ' ' && e.key !== 'Spacebar') return;
      var a = e.target.closest ? e.target.closest('a[data-escolher]') : null;
      if (!a) return;
      e.preventDefault();
      escolher(a.getAttribute('data-escolher'));
    });

    // animacao continua (vibracao, ondas, brilho) so enquanto a peca aparece
    var ioAnda = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.target.classList.toggle('is-vivo', e.isIntersecting); });
    }, { threshold: 0.2 }) : null;
    function andar() { if (ioAnda) document.querySelectorAll('[data-anda]').forEach(function (el) { ioAnda.observe(el); }); }

    // barra: depois do hero, antes do fecho
    var pendente = false;
    function tick() {
      pendente = false;
      var barra = document.querySelector('[data-hbarra]'), hero = document.querySelector('[data-hero-escolha]');
      if (!barra || !hero) return;
      var vh = innerHeight, fim = document.querySelector('[data-hbarra-fim]');
      var ligada = hero.getBoundingClientRect().bottom < 90 && (!fim || fim.getBoundingClientRect().top > vh - 60);
      barra.classList.toggle('is-ligada', ligada);
    }
    function pedir() { if (!pendente) { pendente = true; requestAnimationFrame(tick); } }
    addEventListener('scroll', pedir, { passive: true });
    addEventListener('resize', pedir);

    function iniciar() { preparar(); andar(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["perguntas-grupos"] && !Shopify.designMode) return;
  try {
    
  // Busca sem rede: normaliza (sem acento, minusculas), esconde a pergunta que nao casa, o grupo
  // sem pergunta visivel e o item do indice, e escreve a contagem numa regiao viva. Com ate tres
  // resultados, abre as respostas. Delegado no documento para sobreviver ao editor.
  (function () {
    // a faixa dos diacriticos (U+0300 a U+036F) e montada por codigo, para o arquivo nao carregar caractere combinante solto
    var acentos = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
    var norm = function (t) { return (t || '').normalize('NFD').replace(acentos, '').toLowerCase(); };
    function filtrar(campo) {
      var q = norm(campo.value.trim());
      var itens = document.querySelectorAll('[data-pergunta]');
      var grupos = document.querySelectorAll('[data-perguntas-grupo]');
      var contagem = document.querySelector('[data-perguntas-contagem]');
      var limpar = document.querySelector('[data-perguntas-limpar]');
      var vistos = 0, casados = [];
      itens.forEach(function (it) {
        if (!it.dataset.texto) it.dataset.texto = norm(it.textContent);
        var ok = !q || it.dataset.texto.indexOf(q) >= 0;
        it.hidden = !ok;
        if (ok) { vistos++; casados.push(it); }
      });
      grupos.forEach(function (g) {
        var n = g.querySelectorAll('[data-pergunta]:not([hidden])').length;
        g.hidden = n === 0;
        var idx = document.querySelector('[data-perguntas-indice="' + g.dataset.perguntasGrupo + '"]');
        if (idx) { idx.hidden = n === 0; var num = idx.querySelector('[data-perguntas-indice-n]'); if (num) num.textContent = n; }
      });
      // o name do details faz o acordeao exclusivo por grupo: com mais de um resultado, abrir o segundo fechava o primeiro
      if (q && casados.length === 1) casados[0].open = true;
      if (limpar) limpar.hidden = !q;
      if (!contagem) return;
      if (!q) contagem.textContent = '';
      else if (vistos === 0) contagem.textContent = contagem.dataset.textoNenhuma.replace('[termo]', campo.value.trim());
      else if (vistos === 1) contagem.textContent = contagem.dataset.textoUm;
      else contagem.textContent = contagem.dataset.textoVarias.replace('[n]', vistos);
    }
    document.addEventListener('input', function (e) {
      var campo = e.target.closest('[data-perguntas-busca]');
      if (campo) filtrar(campo);
    });
    document.addEventListener('submit', function (e) {
      if (e.target.matches('[data-perguntas-form]')) e.preventDefault();
    });
    document.addEventListener('reset', function (e) {
      var form = e.target;
      if (!form.matches('[data-perguntas-form]')) return;
      var campo = form.querySelector('[data-perguntas-busca]');
      if (!campo) return;
      setTimeout(function () { filtrar(campo); campo.focus(); }, 0);
    });
    // a pagina pode voltar do historico com o campo preenchido
    var campo = document.querySelector('[data-perguntas-busca]');
    if (campo && campo.value) filtrar(campo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto-app"] && !Shopify.designMode) return;
  try {
    
  // Abas do app: indicador desliza (--ativa), a tela ativa ganha escala e e a unica que toca.
  // movimento.js da play em todo data-video-auto visivel; aqui o play das inativas e desfeito.
  (function () {
    // tocar = false ao montar: quem toca ao entrar na tela e o observador do contrato (VIDEO).
    // Com play() na montagem, o video da aba ativa era buscado com a secao ainda fora da tela.
    function ativar(app, n, foco, tocar) {
      var abas = app.querySelectorAll('[data-aba]'), telas = app.querySelectorAll('[data-tela]');
      abas.forEach(function (a) { var on = parseInt(a.dataset.aba, 10) === n; a.setAttribute('aria-selected', on ? 'true' : 'false'); a.tabIndex = on ? 0 : -1; if (on && foco) a.focus(); });
      telas.forEach(function (t) {
        var on = parseInt(t.dataset.tela, 10) === n; t.classList.toggle('is-ativa', on);
        var v = t.querySelector('video'); if (!v) return;
        if (on) { if (tocar && !document.documentElement.classList.contains('rm')) v.play().catch(function () {}); } else v.pause();
      });
      var abasEl = app.querySelector('.abas'); if (abasEl) abasEl.style.setProperty('--ativa', String(n));
      app.dataset.ativa = String(n);
    }
    function montar(raiz) {
      raiz.querySelectorAll('[data-app]').forEach(function (app) {
        if (app.dataset.pronto) return; app.dataset.pronto = 'true';
        app.querySelectorAll('[data-tela] video').forEach(function (v) {
          v.addEventListener('play', function () { var t = v.closest('[data-tela]'); if (!t.classList.contains('is-ativa')) v.pause(); });
        });
        ativar(app, 0, false, false);
      });
    }
    document.addEventListener('click', function (e) {
      var aba = e.target.closest('[data-aba]'); if (!aba) return;
      ativar(aba.closest('[data-app]'), parseInt(aba.dataset.aba, 10), false, true);
    });
    document.addEventListener('keydown', function (e) {
      var aba = e.target.closest('[data-aba]'); if (!aba) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var app = aba.closest('[data-app]'), total = app.querySelectorAll('[data-aba]').length;
      var n = (parseInt(aba.dataset.aba, 10) + (e.key === 'ArrowRight' ? 1 : -1) + total) % total;
      ativar(app, n, true, true); e.preventDefault();
    });
    montar(document);
    document.addEventListener('shopify:section:load', function (e) { montar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto-barra"] && !Shopify.designMode) return;
  try {
    
  // A barra escuta o botao da caixa: fora da tela, barra visivel. O clique envia o formulario
  // da caixa (que decide entre adicionar e abrir o painel de tamanho) e rola ate ela.
  (function () {
    var html = document.documentElement;
    var io = null;
    function montar() {
      var barra = document.querySelector('[data-barra]');
      var botao = document.querySelector('[data-produto] [data-comprar]');
      if (!barra || !botao || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (es) {
        // so !isIntersecting fazia a barra nascer na primeira tela do celular, com o botao da
        // caixa AINDA abaixo da dobra: a barra so entra quando o botao ja passou para cima
        var r = es[0].boundingClientRect;
        var fora = !es[0].isIntersecting && r.top < 0;
        html.classList.toggle('barra-visivel', fora);
        barra.setAttribute('aria-hidden', fora ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(botao);
    }
    document.addEventListener('produto:variante', function (e) {
      document.querySelectorAll('[data-barra-preco]').forEach(function (p) { p.hidden = String(e.detail.id) !== p.dataset.barraPreco; });
      var botao = document.querySelector('[data-barra-comprar]');
      if (botao && typeof e.detail.disponivel === 'boolean') {
        botao.classList.toggle('is-esgotado', !e.detail.disponivel);
        botao.textContent = e.detail.disponivel ? botao.dataset.rotuloComprar : botao.dataset.rotuloEsgotado;
        if (e.detail.disponivel) { botao.removeAttribute('aria-disabled'); botao.removeAttribute('tabindex'); } else { botao.setAttribute('aria-disabled', 'true'); botao.setAttribute('tabindex', '-1'); }
      }
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-barra-comprar]'); if (!a) return;
      var form = document.querySelector('[data-produto-form]'); if (!form) return;
      e.preventDefault();
      var sec = form.closest('[data-produto]');
      if (sec && sec.dataset.semTamanho === 'true') {
        sec.scrollIntoView({ block: 'start', behavior: html.classList.contains('rm') ? 'auto' : 'smooth' });
        form.requestSubmit();
      } else {
        form.requestSubmit();
      }
    });
    montar();
    document.addEventListener('shopify:section:load', montar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto-compra"] && !Shopify.designMode) return;
  try {
    
  // Caixa de compra: radios escolhem, o JS acha a variante, troca o bloco de preco pronto,
  // a foto do acabamento (crossfade), o id escondido e a URL; sem tamanho, o botao abre o
  // painel em vez de travar. Delegado no documento para sobreviver ao editor.
  (function () {
    var rm = function () { return document.documentElement.classList.contains('rm'); };

    function secaoDe(el) { return el.closest('[data-produto]'); }
    function variantes(sec) { var b = sec.querySelector('[data-variantes]'); return b ? JSON.parse(b.textContent) : []; }
    function escolhas(sec) {
      var lista = [];
      sec.querySelectorAll('[data-opcao]').forEach(function (r) { if (r.checked) lista[parseInt(r.dataset.opcaoIndice, 10)] = r.value; });
      return lista;
    }
    function indiceTamanho(sec) {
      var r = sec.querySelector('[data-opcao-grupo="tamanho"] [data-opcao]');
      return r ? parseInt(r.dataset.opcaoIndice, 10) : -1;
    }

    // galeria: ativa um quadro por indice; a troca e so opacidade (--d-comp no CSS)
    function mostrarQuadro(sec, indice) {
      var quadros = sec.querySelectorAll('[data-quadro]');
      if (!quadros.length) return;
      indice = (indice + quadros.length) % quadros.length;
      quadros.forEach(function (q) {
        var ativo = parseInt(q.dataset.indice, 10) === indice;
        q.classList.toggle('is-ativa', ativo);
      });
      sec.querySelectorAll('[data-mini]').forEach(function (m) {
        var ativo = parseInt(m.dataset.indice, 10) === indice;
        m.classList.toggle('is-ativa', ativo);
        m.setAttribute('aria-pressed', ativo ? 'true' : 'false');
        if (ativo && m.scrollIntoView) m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: rm() ? 'auto' : 'smooth' });
      });
    }
    function quadroAtivo(sec) { var q = sec.querySelector('[data-quadro].is-ativa'); return q ? parseInt(q.dataset.indice, 10) : 0; }
    function mostrarAcabamento(sec, valor) {
      var q = sec.querySelector('[data-quadro][data-acabamento="' + CSS.escape(valor) + '"]');
      if (q) mostrarQuadro(sec, parseInt(q.dataset.indice, 10));
    }

    function atualizar(sec, origem) {
      var lista = variantes(sec), esc = escolhas(sec), iTam = indiceTamanho(sec);
      var semTamanho = iTam >= 0 && !esc[iTam];
      var variante = lista.find(function (v) { return v.options.every(function (o, i) { return i === iTam && semTamanho ? true : o === esc[i]; }); });
      if (semTamanho) {
        // preco e foto do acabamento, com o tamanho ainda em aberto: a primeira disponivel serve
        variante = lista.find(function (v) { return v.available && v.options.every(function (o, i) { return i === iTam || o === esc[i]; }); }) || variante;
      }
      var idInput = sec.querySelector('[data-variante-id]');
      var botao = sec.querySelector('[data-comprar]');
      var rotulo = sec.querySelector('[data-comprar-rotulo]');
      // cada bloco ja traz o riscado da sua variante (ou nao traz): trocar o bloco troca os dois precos
      sec.querySelectorAll('[data-preco-variante]').forEach(function (b) { b.hidden = !variante || String(variante.id) !== b.dataset.precoVariante; });
      var nomeAcab = sec.querySelector('[data-acabamento-nome]'), nomeTam = sec.querySelector('[data-tamanho-nome]');
      var rAcab = sec.querySelector('[data-opcao][data-acabamento]:checked');
      if (nomeAcab && rAcab) nomeAcab.textContent = rAcab.closest('label').querySelector('.swatch__nome').textContent;
      if (nomeTam) nomeTam.textContent = semTamanho ? '' : esc[iTam] || '';
      sec.dataset.semTamanho = semTamanho ? 'true' : 'false';
      if (!variante) {
        botao.disabled = true; rotulo.textContent = botao.dataset.rotuloIndisponivel;
        return;
      }
      idInput.value = variante.id;
      botao.disabled = !variante.available;
      rotulo.textContent = variante.available ? botao.dataset.rotuloAdd : botao.dataset.rotuloEsgotado;
      var avise = sec.querySelector('[data-avise]'); if (avise) avise.hidden = variante.available;
      sec.querySelectorAll('[data-linha-entrega]').forEach(function (prazo) { prazo.hidden = !variante.available; });
      if (origem === 'acabamento' && rAcab) mostrarAcabamento(sec, rAcab.dataset.acabamento);
      if (!semTamanho && origem !== 'inicio' && window.history && history.replaceState) {
        var url = new URL(location.href); url.searchParams.set('variant', variante.id); history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('produto:variante', { detail: { id: variante.id, disponivel: variante.available, semTamanho: semTamanho } }));
    }

    function abrirPainel(sec) {
      var p = sec.querySelector('[data-painel-tamanho]');
      if (!p) return false;
      p.open = true;
      var primeiro = p.querySelector('[data-painel-escolhe]');
      if (primeiro) primeiro.focus();
      return true;
    }
    // fechar devolve o foco ao botao que abriu: sem isso o foco cai no <body>
    function fecharPainel(sec) {
      var p = sec.querySelector('[data-painel-tamanho]');
      if (!p || !p.open) return false;
      p.open = false;
      var b = sec.querySelector('[data-comprar]'); if (b) b.focus();
      return true;
    }
    function abrirMedidor(sec) {
      var d = sec.querySelector('[data-medidor-detalhe]');
      if (!d) return;
      d.open = true;
      var p = sec.querySelector('[data-painel-tamanho]'); if (p) p.open = false;
      d.scrollIntoView({ block: 'start', behavior: rm() ? 'auto' : 'smooth' });
    }
    function marcarTamanho(sec, valor) {
      var r = sec.querySelector('[data-opcao-grupo="tamanho"] [data-opcao][data-valor="' + CSS.escape(valor) + '"]');
      if (!r) return false;
      r.checked = true; atualizar(sec, 'tamanho'); return true;
    }

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-opcao]')) return;
      var sec = secaoDe(e.target); if (!sec) return;
      atualizar(sec, e.target.hasAttribute('data-acabamento') ? 'acabamento' : 'tamanho');
    });

    document.addEventListener('submit', function (e) {
      var form = e.target; if (!form.matches('[data-produto-form]')) return;
      var sec = secaoDe(form); if (!sec) return;
      if (sec.dataset.semTamanho === 'true' && !form.dataset.tamanhoDepois && abrirPainel(sec)) e.preventDefault();
    });

    document.addEventListener('click', function (e) {
      var alvo = e.target.closest('[data-mini], [data-galeria-passo], [data-painel-escolhe], [data-painel-depois], [data-painel-fechar], [data-abrir-medidor], [data-usar-tamanho]');
      if (!alvo) return;
      var sec = secaoDe(alvo); if (!sec) return;
      if (alvo.hasAttribute('data-mini')) { mostrarQuadro(sec, parseInt(alvo.dataset.indice, 10)); return; }
      if (alvo.hasAttribute('data-galeria-passo')) { mostrarQuadro(sec, quadroAtivo(sec) + parseInt(alvo.dataset.galeriaPasso, 10)); return; }
      if (alvo.hasAttribute('data-painel-escolhe')) {
        if (marcarTamanho(sec, alvo.dataset.valor)) { var p = sec.querySelector('[data-painel-tamanho]'); if (p) p.open = false; sec.querySelector('[data-produto-form]').requestSubmit(); }
        return;
      }
      if (alvo.hasAttribute('data-painel-depois')) {
        var form = sec.querySelector('[data-produto-form]');
        var prop = document.createElement('input');
        prop.type = 'hidden'; prop.name = 'properties[' + alvo.dataset.propriedade + ']'; prop.value = alvo.dataset.propriedadeValor;
        form.appendChild(prop); form.dataset.tamanhoDepois = 'true'; form.requestSubmit();
        return;
      }
      if (alvo.hasAttribute('data-painel-fechar')) { fecharPainel(sec); return; }
      if (alvo.hasAttribute('data-abrir-medidor')) { abrirMedidor(sec); return; }
      if (alvo.hasAttribute('data-usar-tamanho')) {
        if (marcarTamanho(sec, alvo.dataset.tamanho)) {
          var d = sec.querySelector('[data-medidor-detalhe]'); if (d) d.open = false;
          var caixa = sec.querySelector('[data-opcao-grupo="tamanho"]'); if (caixa) caixa.scrollIntoView({ block: 'center', behavior: rm() ? 'auto' : 'smooth' });
        }
      }
    });

    // deslize no palco: dx maior que 40 px troca o quadro (com crossfade, nao com arrasto)
    var toque = null;
    document.addEventListener('pointerdown', function (e) { var p = e.target.closest('.galeria__palco'); toque = p ? { x: e.clientX, sec: secaoDe(p) } : null; }, { passive: true });
    document.addEventListener('pointerup', function (e) {
      if (!toque) return; var dx = e.clientX - toque.x; var sec = toque.sec; toque = null;
      if (Math.abs(dx) > 40 && sec) mostrarQuadro(sec, quadroAtivo(sec) + (dx < 0 ? 1 : -1));
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var p = e.target.closest('[data-painel-tamanho]');
        if (p) { var sp = secaoDe(p); if (sp) { fecharPainel(sp); e.preventDefault(); } }
        return;
      }
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target.closest('.galeria__trilho'); if (!t) return;
      var sec = secaoDe(t); mostrarQuadro(sec, quadroAtivo(sec) + (e.key === 'ArrowRight' ? 1 : -1));
      var ativo = sec.querySelector('[data-mini].is-ativa'); if (ativo) ativo.focus();
      e.preventDefault();
    });

    // ===== medidor de tamanho: d(mm) = 11.63 + 0.8128 x tamanho, a mesma conta da tabela =====
    // Este motor tambem existe, identico, em tamanho-medidor.liquid, e a copia e obrigatoria:
    // a Shopify escopa o javascript de cada secao as secoes RENDERIZADAS na pagina
    // (<script id="sections-script" data-sections="...">), e esta secao so vive em template
    // product. Tirar a copia depende de um asset medidor.js, que muda a lista de assets:
    // decisao registrada para o dono. O CSS, esse sim, mora num lugar so (base.css).
    // A pagina Tamanho ouve o evento medidor:resposta para marcar a linha da tabela dela.
    // O cartao ISO/IEC 7810 ID-1 tem 85.6 x 53.98 mm. Um celular de 390 px CSS tem ~6 px por mm:
    // o lado longo pediria ~514 px e nao cabe; o lado curto pede ~324 px e cabe ate em 360.
    // Por isso o lado que calibra e escolhido pelo palco: onde o lado longo cabe a 7,5 px/mm,
    // o cartao fica deitado; senao fica em pe e a largura desenhada e o lado curto.
    var LADO_LONGO = 85.6, LADO_CURTO = 53.98, A = 11.63, B = 0.8128, SOBE = 0.35, PXMM_MAX = 9;
    function tamanhoDe(d, min, max) {
      var x = (d - A) / B, t = Math.floor(x), frac = x - t, subiu = false;
      if (frac >= SOBE) { t += 1; subiu = frac < 1; }
      if (t < min || t > max) return { fora: true };
      return { t: t, subiu: subiu };
    }
    function prepMedidor(m) {
      if (m.dataset.pronto) return; m.dataset.pronto = 'true';
      var caixa = m.querySelector('[data-medidor-caixa]'); if (!caixa) return;
      caixa.hidden = false;
      var min = parseInt(m.dataset.min, 10), max = parseInt(m.dataset.max, 10);
      var rc = m.querySelector('[data-range="cartao"]'), ra = m.querySelector('[data-range="anel"]');
      var cartao = m.querySelector('[data-cartao]'), disco = m.querySelector('[data-disco]');
      var leitura = m.querySelector('[data-leitura="cartao"]'), lembrado = m.querySelector('[data-lembrado]');
      var cheio = m.querySelector('[data-cheio]'), sTam = m.querySelector('[data-tamanho]'), sMed = m.querySelector('[data-medida]'), sAviso = m.querySelector('[data-aviso]'), usar = m.querySelector('[data-usar-tamanho]');
      var textos = { medida: sMed.dataset.modelo, subiu: sAviso.dataset.subiu, fora: sAviso.dataset.fora, usar: usar.dataset.modelo, leitura: leitura.dataset.modelo };
      var ladoMm = LADO_LONGO, pxmm = parseFloat(rc.value) / ladoMm;
      var dMin = A + B * min, dMax = A + B * max;
      // o palco decide o lado: o cartao deitado so quando o lado longo cabe a 7,5 px/mm
      function limitar() {
        var largo = cartao.parentElement.clientWidth - 16; if (largo < 100) return;
        ladoMm = largo >= LADO_LONGO * 7.5 ? LADO_LONGO : LADO_CURTO;
        cartao.dataset.lado = ladoMm === LADO_LONGO ? 'longo' : 'curto';
        rc.min = String(Math.round(ladoMm * 2.5)); rc.max = String(Math.min(Math.round(ladoMm * PXMM_MAX), largo));
        rc.value = String(Math.max(parseFloat(rc.min), Math.min(parseFloat(rc.max), pxmm * ladoMm)));
        cartaoMudou(false);
      }
      try { var salvo = localStorage.getItem('ezeed-pxmm'); if (salvo && parseFloat(salvo) > 0) { pxmm = parseFloat(salvo); lembrado.hidden = false; } } catch (err) {}
      function responder(d) {
        cheio.hidden = false;
        var r = tamanhoDe(d, min, max);
        sMed.textContent = textos.medida.replace('[mm]', d.toFixed(1).replace('.', ','));
        m.querySelectorAll('[data-linha-tamanho]').forEach(function (tr) { tr.classList.toggle('is-marcada', !r.fora && parseInt(tr.dataset.linhaTamanho, 10) === r.t); });
        // a pagina Tamanho ouve isto para marcar a linha da tabela dela: uma conta, dois lugares
        document.dispatchEvent(new CustomEvent('medidor:resposta', { detail: { tamanho: r.fora ? null : r.t, fora: !!r.fora, mm: d } }));
        if (r.fora) { sTam.textContent = '—'; sAviso.hidden = false; sAviso.textContent = textos.fora; usar.hidden = true; return; }
        sTam.textContent = String(r.t);
        sAviso.hidden = !r.subiu; sAviso.textContent = r.subiu ? textos.subiu : '';
        usar.hidden = false; usar.dataset.tamanho = String(r.t); usar.textContent = textos.usar.replace('[tamanho]', String(r.t));
      }
      // o valor de um range e um numero sem significado para quem nao ve o cartao nem o disco
      function dizerValor(inp, mm) {
        if (!inp.dataset.valorModelo) return;
        inp.setAttribute('aria-valuetext', inp.dataset.valorModelo.replace('[mm]', mm.toFixed(1).replace('.', ',')));
      }
      function cartaoMudou(guardar) {
        pxmm = parseFloat(rc.value) / ladoMm;
        cartao.style.setProperty('--w', rc.value + 'px');
        dizerValor(rc, ladoMm);
        leitura.textContent = textos.leitura;
        if (guardar !== false) { try { localStorage.setItem('ezeed-pxmm', String(pxmm)); } catch (err) {} }
        // o disco vai do menor ao maior tamanho fabricado, na escala calibrada, com folga
        ra.min = String(Math.floor(dMin * pxmm * 0.85)); ra.max = String(Math.ceil(dMax * pxmm * 1.15));
        if (!ra.dataset.tocado) ra.value = String(Math.round((dMin + dMax) / 2 * pxmm));
        anelMudou();
      }
      function anelMudou() {
        disco.style.setProperty('--d', ra.value + 'px');
        var mm = parseFloat(ra.value) / pxmm;
        dizerValor(ra, mm);
        if (ra.dataset.tocado) responder(mm);
      }
      rc.addEventListener('input', function () { cartaoMudou(true); });
      ra.addEventListener('input', function () { ra.dataset.tocado = 'true'; anelMudou(); });
      limitar(); addEventListener('resize', limitar);
      // o medidor nasce dentro de um <details> fechado (palco com largura zero): mede de novo quando ganha tamanho
      if ('ResizeObserver' in window) new ResizeObserver(function () { limitar(); }).observe(cartao.parentElement);
      else { var det = m.closest('details'); if (det) det.addEventListener('toggle', limitar); }
      m.querySelectorAll('[data-entrada]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var v = parseFloat(inp.value.replace(',', '.')); if (!(v > 0)) return;
          responder(inp.dataset.entrada === 'circ' ? v / Math.PI : v);
        });
      });
    }
    // ao montar: o estado inicial (tamanho em aberto ou nao) e os medidores
    function montar(raiz) {
      raiz.querySelectorAll('[data-produto]').forEach(function (sec) { atualizar(sec, 'inicio'); });
      raiz.querySelectorAll('[data-medidor]').forEach(prepMedidor);
    }
    montar(document);
    document.addEventListener('shopify:section:load', function (e) { montar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto-fecho"] && !Shopify.designMode) return;
  try {
    
  // O botao rola ate a caixa de compra e leva o foco ao primeiro tamanho, sem trocar a URL.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ir-compra]'); if (!a) return;
    var caixa = document.querySelector('[data-caixa-compra]'); if (!caixa) return;
    e.preventDefault();
    caixa.scrollIntoView({ block: 'start', behavior: document.documentElement.classList.contains('rm') ? 'auto' : 'smooth' });
    var alvo = caixa.querySelector('[data-opcao-grupo="tamanho"] input') || caixa.querySelector('[data-comprar]');
    if (alvo) alvo.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rastreio-como"] && !Shopify.designMode) return;
  try {
    
  // Abre o rastreio da transportadora em nova aba. Com "parametro" preenchido, o codigo vai na
  // URL; sem ele (o caso dos Correios hoje: a pagina nao le a URL e tem captcha), o codigo e
  // copiado para a area de transferencia e a pagina abre limpa, com o aviso na regiao viva.
  (function () {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-rastreio]');
      if (!form) return;
      e.preventDefault();
      var campo = form.querySelector('[data-rastreio-codigo]');
      var estado = form.querySelector('[data-rastreio-estado]');
      var codigo = (campo.value || '').replace(/\s+/g, '').toUpperCase();
      campo.value = codigo;
      estado.classList.remove('is-ok');
      if (!codigo) { estado.textContent = form.dataset.textoVazio; campo.focus(); return; }
      var base = form.dataset.url, param = (form.dataset.parametro || '').trim();
      if (param) {
        var url = base + (base.indexOf('?') >= 0 ? '&' : '?') + encodeURIComponent(param) + '=' + encodeURIComponent(codigo);
        window.open(url, '_blank', 'noopener');
        estado.textContent = form.dataset.textoAberto;
        estado.classList.add('is-ok');
        return;
      }
      var mostrar = function () { window.open(base, '_blank', 'noopener'); estado.textContent = form.dataset.textoCopiado; estado.classList.add('is-ok'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(codigo).then(mostrar, mostrar);
      else { campo.select(); try { document.execCommand('copy'); } catch (err) {} mostrar(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rodape"]) return;
  try {
    
  // No celular os grupos do menu nascem fechados; ao voltar ao desktop abrem de novo, porque la
  // o summary some e o conteudo precisa estar visivel. Sem JS ficam abertos (pilha simples).
  (function () {
    var mq = matchMedia('(max-width: 767px)');
    function ajustar() {
      document.querySelectorAll('[data-rodape-grupo]').forEach(function (d) { d.open = !mq.matches; });
    }
    ajustar();
    mq.addEventListener('change', ajustar);
    document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-rodape]')) ajustar(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tamanho-medidor"] && !Shopify.designMode) return;
  try {
    
  // MOTOR DO MEDIDOR — copia literal do de produto-compra.liquid, e a copia e obrigatoria:
  // a Shopify escopa o javascript de cada secao as secoes RENDERIZADAS na pagina
  // (<script id="sections-script" data-sections="...">), e produto-compra nao vive em
  // template page. Quem desenha o snippet tamanho-medidor precisa levar o motor junto.
  // A conta e a mesma da tabela: d(mm) = 11.63 + 0.8128 x tamanho; o cartao ISO/IEC 7810
  // ID-1 tem 85.6 x 53.98 mm e o palco decide o lado que calibra.
  // O CSS, esse sim, mora num lugar so (base.css). Tirar esta copia depende de um asset
  // medidor.js, que muda a lista de assets: decisao registrada para o dono (Etapa 4).
  // O que e desta pagina fica no fim: marcar a linha da tabela desta pagina pelo evento
  // medidor:resposta, e "Usar o tamanho N", que abre a PDP com a variante ja escolhida.
  (function () {
    var LADO_LONGO = 85.6, LADO_CURTO = 53.98, A = 11.63, B = 0.8128, SOBE = 0.35, PXMM_MAX = 9;
    function tamanhoDe(d, min, max) {
      var x = (d - A) / B, t = Math.floor(x), frac = x - t, subiu = false;
      if (frac >= SOBE) { t += 1; subiu = frac < 1; }
      if (t < min || t > max) return { fora: true };
      return { t: t, subiu: subiu };
    }
    function prepMedidor(m) {
      if (m.dataset.pronto) return; m.dataset.pronto = 'true';
      var caixa = m.querySelector('[data-medidor-caixa]'); if (!caixa) return;
      caixa.hidden = false;
      var min = parseInt(m.dataset.min, 10), max = parseInt(m.dataset.max, 10);
      var rc = m.querySelector('[data-range="cartao"]'), ra = m.querySelector('[data-range="anel"]');
      var cartao = m.querySelector('[data-cartao]'), disco = m.querySelector('[data-disco]');
      var leitura = m.querySelector('[data-leitura="cartao"]'), lembrado = m.querySelector('[data-lembrado]');
      var cheio = m.querySelector('[data-cheio]'), sTam = m.querySelector('[data-tamanho]'), sMed = m.querySelector('[data-medida]'), sAviso = m.querySelector('[data-aviso]'), usar = m.querySelector('[data-usar-tamanho]');
      var textos = { medida: sMed.dataset.modelo, subiu: sAviso.dataset.subiu, fora: sAviso.dataset.fora, usar: usar.dataset.modelo, leitura: leitura.dataset.modelo };
      var ladoMm = LADO_LONGO, pxmm = parseFloat(rc.value) / ladoMm;
      var dMin = A + B * min, dMax = A + B * max;
      // o palco decide o lado: o cartao deitado so quando o lado longo cabe a 7,5 px/mm
      function limitar() {
        var largo = cartao.parentElement.clientWidth - 16; if (largo < 100) return;
        ladoMm = largo >= LADO_LONGO * 7.5 ? LADO_LONGO : LADO_CURTO;
        cartao.dataset.lado = ladoMm === LADO_LONGO ? 'longo' : 'curto';
        rc.min = String(Math.round(ladoMm * 2.5)); rc.max = String(Math.min(Math.round(ladoMm * PXMM_MAX), largo));
        rc.value = String(Math.max(parseFloat(rc.min), Math.min(parseFloat(rc.max), pxmm * ladoMm)));
        cartaoMudou(false);
      }
      try { var salvo = localStorage.getItem('ezeed-pxmm'); if (salvo && parseFloat(salvo) > 0) { pxmm = parseFloat(salvo); lembrado.hidden = false; } } catch (err) {}
      function responder(d) {
        cheio.hidden = false;
        var r = tamanhoDe(d, min, max);
        sMed.textContent = textos.medida.replace('[mm]', d.toFixed(1).replace('.', ','));
        m.querySelectorAll('[data-linha-tamanho]').forEach(function (tr) { tr.classList.toggle('is-marcada', !r.fora && parseInt(tr.dataset.linhaTamanho, 10) === r.t); });
        // a pagina Tamanho ouve isto para marcar a linha da tabela dela: uma conta, dois lugares
        document.dispatchEvent(new CustomEvent('medidor:resposta', { detail: { tamanho: r.fora ? null : r.t, fora: !!r.fora, mm: d } }));
        if (r.fora) { sTam.textContent = '—'; sAviso.hidden = false; sAviso.textContent = textos.fora; usar.hidden = true; return; }
        sTam.textContent = String(r.t);
        sAviso.hidden = !r.subiu; sAviso.textContent = r.subiu ? textos.subiu : '';
        usar.hidden = false; usar.dataset.tamanho = String(r.t); usar.textContent = textos.usar.replace('[tamanho]', String(r.t));
      }
      // o valor de um range e um numero sem significado para quem nao ve o cartao nem o disco
      function dizerValor(inp, mm) {
        if (!inp.dataset.valorModelo) return;
        inp.setAttribute('aria-valuetext', inp.dataset.valorModelo.replace('[mm]', mm.toFixed(1).replace('.', ',')));
      }
      function cartaoMudou(guardar) {
        pxmm = parseFloat(rc.value) / ladoMm;
        cartao.style.setProperty('--w', rc.value + 'px');
        dizerValor(rc, ladoMm);
        leitura.textContent = textos.leitura;
        if (guardar !== false) { try { localStorage.setItem('ezeed-pxmm', String(pxmm)); } catch (err) {} }
        // o disco vai do menor ao maior tamanho fabricado, na escala calibrada, com folga
        ra.min = String(Math.floor(dMin * pxmm * 0.85)); ra.max = String(Math.ceil(dMax * pxmm * 1.15));
        if (!ra.dataset.tocado) ra.value = String(Math.round((dMin + dMax) / 2 * pxmm));
        anelMudou();
      }
      function anelMudou() {
        disco.style.setProperty('--d', ra.value + 'px');
        var mm = parseFloat(ra.value) / pxmm;
        dizerValor(ra, mm);
        if (ra.dataset.tocado) responder(mm);
      }
      rc.addEventListener('input', function () { cartaoMudou(true); });
      ra.addEventListener('input', function () { ra.dataset.tocado = 'true'; anelMudou(); });
      limitar(); addEventListener('resize', limitar);
      // o medidor nasce dentro de um <details> fechado (palco com largura zero): mede de novo quando ganha tamanho
      if ('ResizeObserver' in window) new ResizeObserver(function () { limitar(); }).observe(cartao.parentElement);
      else { var det = m.closest('details'); if (det) det.addEventListener('toggle', limitar); }
      m.querySelectorAll('[data-entrada]').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var v = parseFloat(inp.value.replace(',', '.')); if (!(v > 0)) return;
          responder(inp.dataset.entrada === 'circ' ? v / Math.PI : v);
        });
      });
    }
    function montar(raiz) { raiz.querySelectorAll('[data-tamanho-medidor] [data-medidor]').forEach(prepMedidor); }
    montar(document);
    document.addEventListener('shopify:section:load', function (e) { montar(e.target); });

    // ==== o que e desta pagina ====
    function marcarLinhas(t) {
      document.querySelectorAll('[data-tamanho-linha]').forEach(function (tr) {
        var on = t !== null && parseInt(tr.dataset.tamanhoLinha, 10) === t;
        tr.classList.toggle('is-ativa', on);
        if (on) tr.setAttribute('aria-current', 'true'); else tr.removeAttribute('aria-current');
      });
    }
    document.addEventListener('medidor:resposta', function (e) { marcarLinhas(e.detail.fora ? null : e.detail.tamanho); });
    document.addEventListener('click', function (e) {
      var botao = e.target.closest('[data-usar-tamanho]'); if (!botao) return;
      var sec = botao.closest('[data-tamanho-medidor]'); if (!sec || !sec.dataset.urlAnel) return;
      var mapa = {}; try { var j = sec.querySelector('[data-tamanho-variantes]'); mapa = j ? JSON.parse(j.textContent) : {}; } catch (err) { mapa = {}; }
      var id = mapa[botao.dataset.tamanho];
      location.href = sec.dataset.urlAnel + (id ? '?variant=' + id : '') + '#caixa-compra';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
